import store from 'lib/store';
import xray from 'lib/xray';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import {
    SECOND_CLICK_TIP_HOME_KEY,
    SECOND_CLICK_TIP_KEY,
    SECOND_CLICK_TIP_PUBLIC_KEY,
    SECOND_CLICK_TIP_QUOTA_CLEANER_KEY,
} from 'reactApp/ui/Datalist/DataList.constants';
import { TipContent } from 'reactApp/ui/Datalist/Item/TipContent';
import { noop } from 'reactApp/utils/helpers';

export const tips = [
    {
        id: SECOND_CLICK_TIP_HOME_KEY,
        getTipContent: TipContent,
        onHideClick: noop as (id: string) => void,
    },
];

const tipStorageKeys = {
    [EStorageType.public]: SECOND_CLICK_TIP_PUBLIC_KEY,
    [EStorageType.quotaCleaner]: SECOND_CLICK_TIP_QUOTA_CLEANER_KEY,
    [EStorageType.home]: SECOND_CLICK_TIP_HOME_KEY,
};

export const getSelectedCount = (key: string, columnCount: number): number => {
    switch (key) {
        case 'ArrowDown':
            return columnCount;
        case 'ArrowUp':
            return -columnCount;
        case 'ArrowLeft':
            return -1;
        case 'ArrowRight':
            return 1;
        default:
            return 0;
    }
};

export const logHandler = ({ radars, radarName }: { radars?: string[]; radarName: string }): void => {
    if (radars) {
        for (const element of radars) {
            const r = element.split('=');

            xray.send('datalist', {
                i: {
                    [`${radarName}_${r[0]}`]: Number(r[1]),
                },
            });
        }
    } else {
        xray.send(`datalist_${radarName}`);
    }
};

export const getShowSecondClickTip = ({ selectedCount, email, isDragging, disableTips, currentStorage }) => {
    let showSecondClickTip = selectedCount > 0 && !store.get(`${email}|${SECOND_CLICK_TIP_KEY}`) && !isDragging;

    if (!(selectedCount > 0 && !disableTips)) {
        return showSecondClickTip;
    }

    const dayOffsetMs = 24 * 60 * 60 * 1000;
    const nowMs = Date.now();
    let clickTipShownInHomeTime: number | undefined = store.get(`${email}|${SECOND_CLICK_TIP_KEY}`) && nowMs - dayOffsetMs;

    if (!clickTipShownInHomeTime) {
        clickTipShownInHomeTime = store.get(`${email}|${tipStorageKeys[EStorageType.home]}`);
    }

    tips[0].id = tipStorageKeys[currentStorage];

    const timeMap = {
        [EStorageType.home]: clickTipShownInHomeTime,
        [EStorageType.public]: store.get(`${email}|${tipStorageKeys[EStorageType.public]}`),
        [EStorageType.quotaCleaner]: store.get(`${email}|${tipStorageKeys[EStorageType.quotaCleaner]}`),
    };

    showSecondClickTip =
        !timeMap[currentStorage] &&
        Object.entries(timeMap).every(([storage, shownTime]) => {
            if (storage === currentStorage) {
                return true;
            }

            return !shownTime || nowMs - shownTime >= dayOffsetMs;
        });

    return showSecondClickTip;
};
